import { useQueryClient } from '@tanstack/react-query';

import { getApiV1PersonQueryOptions, usePostApiV1Person } from '@/shared/api/generated';

/**
 * Hook para criar uma nova pessoa.
 *
 * Invalida automaticamente a listagem após a criação bem-sucedida.
 *
 * @example
 * ```tsx
 * const createPerson = useCreatePerson();
 * createPerson.mutate({ data: { firstName: 'João', ... } });
 * ```
 */
export function useCreatePerson() {
  const queryClient = useQueryClient();

  return usePostApiV1Person({
    mutation: {
      onSuccess: () => {
        void queryClient.invalidateQueries(getApiV1PersonQueryOptions());
      },
    },
  });
}
